import React from 'react';

import { TFunction } from 'i18next';

import { IBudgetItem } from 'modules/checkout/domain/entities';
import { TItemType } from 'shared/domain/entities';
import { PackageImage, Tooltip } from 'shared/presentation/components/atoms';
import { ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';

const IconWarning = ICONS.ALERT_CIRCLE;

const NAME_BY_TYPE: Record<TItemType, (t: TFunction<'checkout'>) => string> = {
  PRODUCT: t => t('Product'),
  PACKAGE: t => t('Package'),
  COMBO: t => t('Combo'),
};

const ITEMS_SIZE = {
  DESKTOP: 80,
  MOBILE: 24,
};

interface IBudgetItemProps {
  item: IBudgetItem;
}

const BudgetItem: React.FC<IBudgetItemProps> = ({ item }) => {
  const { t } = useLocale('checkout');
  const isMobile = useMediaQuery('md');

  return (
    <S.Container>
      <section>
        <PackageImage
          src={item.image}
          alt={item.title}
          size={isMobile ? ITEMS_SIZE.MOBILE : ITEMS_SIZE.DESKTOP}
        />

        <div className="info">
          <span>
            {t('{{item}} with {{sessions}} sessions of', {
              item: NAME_BY_TYPE[item.type](t),
              sessions: item.sessions,
              count: item.sessions,
            })}
          </span>

          <strong>{item.title}</strong>
        </div>
      </section>

      {!!item.blockingMessage && (
        <Tooltip
          content={
            <S.Tooltip>
              <span>{item.blockingMessage}</span>
            </S.Tooltip>
          }
        >
          <S.Warning>
            <IconWarning />
          </S.Warning>
        </Tooltip>
      )}
    </S.Container>
  );
};

export default BudgetItem;
